import React from 'react'

import { EmailCaptureTitle, EmailCaptureSubtitle } from './'

const EmailCapture = (props) => {
	return (
		<div>
			<EmailCaptureTitle {...props}/>
			<EmailCaptureSubtitle {...props} />
			<style jsx>{`
				div {
					font-size: 12px;
					text-align: center;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					height: 50vh;
				}

				@media (max-width: 769px), (pointer: coarse) {
					div {
						padding: 0 20px;
					}
					
				}
			`}</style>
		</div>
	)
}

export default EmailCapture
